import React from 'react';
import SEO from './SEO';
import Hero from './Hero';
import BlackSection from './BlackSection';
import DataServices from './DataServices';
import SecondHeroSection from './SecondHeroSection';
import ThreeContainersSection from './ThreeContainersSection';
// import Tanantech from './Tanantech';
import LetsTalk from './LetsTalk';
import ArticleCarousel from './ArticleCarousel';

const Home = () => {
  return (
    <>
      <SEO
        title="Lloyd James Media – More Than Just Data"
        description="Expert data consultancy services for businesses. Specializing in data management, analysis, cleansing, and strategic insights to drive business growth."
        keywords="data consultancy, data management, business intelligence, data analysis, data cleansing, Lloyd James"
        ogUrl={import.meta.env.VITE_SITE_URL || 'https://www.lloydjames.com'}
      />
      <main className="min-h-screen">
        <Hero />
        <BlackSection />
        <DataServices />
        <SecondHeroSection />
        <ThreeContainersSection />
        {/* <Tanantech /> */}
        <LetsTalk />
        <ArticleCarousel />
      </main>
    </>
  );
};

export default Home;